import type { TeacherResult } from '../../shared/results';
import { formatTurkishLira } from '../../shared/billionaire';

export function ResultCorrectionReview({ result }: { result: TeacherResult }) {
  const correction = result.correction;
  if (!correction) return null;
  const format = (score: number) => result.templateKey === 'billionaire-quiz' ? formatTurkishLira(score) : `${score} puan`;
  return <details className="result-correction-review">
    <summary>{correction.policy === 'recalculated' ? 'Cevaplar ve puan düzeltildi' : 'Doğru cevap güncellendi · Puan korundu'}</summary>
    <p>{correction.policy === 'recalculated'
      ? `${format(correction.originalScore)} → ${format(result.score)}. Seri ve bonuslar yeniden hesaplandı; oyun hareketleri ve süre korunur.`
      : correction.policy === 'three-lives-preserved' ? 'Canlı mod: oyun sırasında kaydedilen puan ve ilerleme korunur.'
      : 'Eski kayıtta yeterli seçim bilgisi bulunmadığı için puan yeniden hesaplanamadı.'}</p>
    <ul>{correction.answers.map((answer, i) => <li key={i}>
      <strong>{answer.level}{answer.question ? `.${answer.question}` : ''}. {answer.prompt}</strong><br />
      {answer.correct !== null && <span>Güncel değerlendirme: {answer.correct ? '✓ Doğru' : '✕ Yanlış'} · Seçilen: {answer.selectedAnswer ?? 'Süre doldu'} · </span>}
      Doğru cevap: {answer.correctAnswer}
      {answer.correctMediaUrl && <img className="publication-edit-media" src={answer.correctMediaUrl} alt="Güncel doğru cevap görseli" />}
    </li>)}</ul>
  </details>;
}
